import ToastHighLighter from '@/lib/ToastHighLighter';

export const PaginationCode = () => {
  const language = 'html';
  const codeString = `
  // Pagination
  <nav aria-label="Page navigation example">
    <ul class="pagination">
      <li class="page-item">
        <a class="page-link" href="#">
          Previous
        </a>
      </li>
      <li class="page-item">
        <a class="page-link" href="#">
          1
        </a>
      </li>
      <li class="page-item active">
        <a class="page-link" href="#">
          2
        </a>
      </li>
      <li class="page-item">
        <a class="page-link" href="#">
          3
        </a>
      </li>
      <li class="page-item">
        <a class="page-link" href="#">
          Next
        </a>
      </li>
    </ul>
  </nav>
  `;

  return (
    <>
      <ToastHighLighter
        name={'breadcrumb'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
